export function toolText(text: string) {
  return { content: [{ type: 'text' as const, text }] };
}

export function toolJson(data: unknown) {
  return { content: [{ type: 'text' as const, text: JSON.stringify(data, null, 2) }] };
}
